import React, { useState } from "react";
import { Table, Button, Input, Space, Modal, message, Descriptions, Spin, Col, Row, } from 'antd';
import strings from '../../utils/strings';
import { SearchOutlined, ZoomInOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import moment from 'moment-jalaali';
import axios from 'axios';
import config from "../../config";
import { usePersistedStore } from "../../store/persisted-store";
import { useNonePersistedStore } from "../../store/non-persisted-store";

export default function ReceiptsTable() {

    const { auth, business } = usePersistedStore();
    const { receipts } = useNonePersistedStore()
    const data = receipts.rceipts;
    const loading = receipts.loading;
    const businessToken = business.currentBusiness.token;
    const userToken = auth.userToken;

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [, setRequestId] = useState();
    const [visible, setVisible] = useState(false);
    const [details, setDetails] = useState();
    const [srvLoading, setSrvLoading] = useState(false);

    let searchInput;
    const getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node;
                    }}
                    placeholder={`جستجو ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}>
                        جستجو
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>ریست</Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (text),
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getDetails = (id) => {
        try {
            setSrvLoading(true);
            axios({
                method: "GET",
                baseURL: config.apiUrls(),
                url: `v1/payment/receipt/${id}/Info`,
                headers: { "token": businessToken, Authorization: `Bearer ${userToken}` }
            }).then((response) => {
                setDetails(response.data.Details);
                setSrvLoading(false);
            })
        } catch (error) {
            setSrvLoading(false);
            setDetails(null);
            message.error(error.Message)
        }
    }

    const columns = [
        {
            title: "جزئیات",
            dataIndex: "operation",
            key: "operation",
            width: 85,
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">
                        <Button type='link' onClick={() => {
                            getDetails(record.Id);
                            setRequestId(record.Id);
                            setVisible(true);
                        }
                        }><ZoomInOutlined /></Button>
                    </Space>
                ),
        },
        {
            title: "آی دی",
            dataIndex: "ReceiptId",
            key: "ReceiptId",
            ...getColumnSearchProps('ReceiptId', 'آی دی'),
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },
        {
            title: "نوع",
            dataIndex: "ReceiptType",
            key: "ReceiptType",
            ...getColumnSearchProps('ReceiptType', 'نوع'),
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },
        {
            title: "مبلغ کل",
            dataIndex: "Amount",
            key: "Amount",
            ...getColumnSearchProps('Amount', 'مبلغ کل'),
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "مبلغ پرداختی",
            dataIndex: "SumPayment",
            key: "SumPayment",
            ...getColumnSearchProps('SumPayment', 'مبلغ پرداختی'),
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "کیف پول",
            dataIndex: "Wallet",
            key: "Wallet",
            ...getColumnSearchProps('Wallet', 'کیف پول'),
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "مغایرت",
            dataIndex: "ContradictionAmount",
            key: "ContradictionAmount",
            ...getColumnSearchProps('ContradictionAmount', 'مغایرت'),
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        // {
        //     title: "آی دی پرداخت کننده",
        //     dataIndex: "DebitUserId",
        //     key: "DebitUserId",
        //     ...getColumnSearchProps('DebitUserId', 'پرداخت کننده'),
        //     render: data => strings.getFarsiNum(data)
        // },
        {
            title: "پرداخت کننده",
            dataIndex: "DebitUsername",
            key: "DebitUsername",
            ...getColumnSearchProps('DebitUsername', 'پرداخت کننده'),
            render: data => strings.getFarsiNum(data)
        },
        {
            title: "کد پیگیری",
            dataIndex: "TrackingCode",
            key: "TrackingCode",
            ...getColumnSearchProps('TrackingCode', 'مبلغ'),
            render: data => data
        },
        {
            title: 'تاریخ ایجاد',
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },
        {
            title: "توضیحات",
            dataIndex: "Description",
            key: "Description",
            ...getColumnSearchProps('Description', 'کد پرداخت')
        },
    ];

    return (
        <>
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                size="middle"
                bordered
                columns={columns}
                loading={loading}
                rowKey="ReceiptId"
                dataSource={data}
                scroll={true}
            />
            <Modal
                width={900}
                title="جزئیات فاکتور"
                className="custom-table"
                visible={visible}
                footer={false}
                onCancel={() => setVisible(false)}>
                <Spin spinning={srvLoading}>
                    <Row>
                        {details?.length && details?.map((item, index) => {
                            return <Col span={8}>
                                <Descriptions key={index}>
                                    <Descriptions.Item label={item.Title} className="font-bold">
                                        {item.Value}
                                    </Descriptions.Item>
                                </Descriptions>
                            </Col>
                        })}
                    </Row>
                </Spin>
            </Modal>
        </>
    );
}
